import type { Client } from 'urql'
import {
  CreateOrderPhoto,
  PresignOrderPhotoUpload,
} from '../graphql/orderPhotos'
import type { PhotoUploader } from './photoQueueDrain'
import { putToPresignedUrl } from './photoUpload'

/**
 * GraphQL transport for the photo queue drain: maps the presign/create
 * mutations onto the `PhotoUploader` contract. Kept out of the provider so
 * the error branches are unit-testable without mounting React.
 */
export function createPhotoQueueUploader(client: Client): PhotoUploader {
  return {
    presign: async (entry) => {
      const result = await client
        .mutation(PresignOrderPhotoUpload, {
          orderId: entry.orderId,
          data: { clientId: entry.clientId, contentType: entry.contentType },
        })
        .toPromise()
      const urls = result.data?.orderPhoto?.presignUpload
      const presignFailed = result.error !== undefined || urls == null
      if (presignFailed) {
        throw result.error ?? new Error('presignUpload returned no urls')
      }
      return urls
    },
    put: putToPresignedUrl,
    create: async (entry) => {
      const result = await client
        .mutation(CreateOrderPhoto, {
          orderId: entry.orderId,
          data: {
            clientId: entry.clientId,
            contentType: entry.contentType,
            width: entry.width,
            height: entry.height,
            takenAt: entry.takenAtIso,
          },
        })
        .toPromise()
      const created = result.data?.orderPhoto?.create
      const createFailed = result.error !== undefined || created == null
      if (createFailed) {
        throw result.error ?? new Error('create returned no photo')
      }
    },
  }
}
